import { render, staticRenderFns } from "./_upgradeModal.vue?vue&type=template&id=1ae8246a"
import script from "./_upgradeModal.vue?vue&type=script&lang=js"
export * from "./_upgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports